/* eslint max-classes-per-file: 0 */
/* eslint no-use-before-define: 0 */

import { Store } from 'vuex'
import { Menu } from '@/typings/common'

import {
  Getters,
  Mutations,
  Actions,
  Module,
  Context,
  createMapper,
} from 'vuex-smart-module'
import { authStoreModule } from '@/views/Auth/store'
import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'
import { MenuFolder } from '@/helpers/enums/menu-folders'
import { createGetMenuItem } from './utils'
import SiteDetectionMixin from '@/helpers/siteDetectionMixin'


type S = PreferenceState
type G = PreferenceGetters
type M = PreferenceMutations
type A = PreferenceActions


const selectedMenuSystem = Object
  .values(MENU_FOLDERS)
  .find((_) => window.location.pathname.includes(_.name))
  || MENU_FOLDERS.SERVICE_LK

class PreferenceState {
  public selectedMenuSystem: MenuFolder = selectedMenuSystem;

  public readonly navigationDrawer = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    menu: [] as Menu[],
    mini: false,
  };
}

class PreferenceGetters extends Getters<S> {
  private store!: Store<unknown>;

  private auth!: Context<typeof authStoreModule>;

  public $init(store: Store<unknown>): void {
    this.store = store
    this.auth = authStoreModule.context(store)
  }

  public get menu() {
    const router = this.store.$router
    const { profile } = this.auth.getters
    let { menu } = this.state.navigationDrawer

    // Фильтруем MENU_ROADMAPS если isSoop не равен true
    const isSoop = SiteDetectionMixin.computed.isSoop()
    if (!isSoop) {
      menu = menu.filter((item) => item.id !== 'roadmaps')
    }

    const getMenuItem = createGetMenuItem(router, profile)
    return menu.map(getMenuItem)
  }
}

class PreferenceMutations extends Mutations<S> {
  public toggleNavigationDrawerMini() {
    this.state.navigationDrawer.mini = !this.state.navigationDrawer.mini
  }

  public setMenuSystem(data: MenuFolder) {
    this.state.selectedMenuSystem = data
  }

  public registerNavigationDrawerMenu(payload: Menu[]) {
    this.state.navigationDrawer.menu = payload
  }
}

class PreferenceActions extends Actions<S, G, M, A> {
  public toggleNavigationDrawerMini() {
    this.mutations.toggleNavigationDrawerMini()
  }

  public setMenuSystem(data: MenuFolder) {
    this.mutations.setMenuSystem(data)
  }

  public registerNavigationDrawerMenu(payload: Menu[]) {
    this.mutations.registerNavigationDrawerMenu(payload)
  }
}

const storeModule = new Module({
  namespaced: true,
  state: PreferenceState,
  getters: PreferenceGetters,
  mutations: PreferenceMutations,
  actions: PreferenceActions,
})

const mapper = createMapper(storeModule)

export {
  storeModule as preferenceStoreModule,
  mapper as preferenceMapper,
}
